import React, { useEffect, useState, useRef, useMemo  } from "react";
import { GoPeople } from "react-icons/go";
import Bycall from "../../pages/expert/Modals/bycall";
import Bychat from "../../pages/expert/Modals/bychat";
import Bycredit from "../../pages/expert/Modals/bycredit";
import Buycredit from "../../pages/expert/Modals/buycredit";
import axios from "axios";
import Swal from "sweetalert2";
import Spinner from "../../components/Spinner/spinner";
import LoadingSpinner from "../LoadingSpinner/loadingSpinner";
import avatar from "../../assets/images/profile.jpg";
import Cookies from "js-cookie";
import api from "../../api";
import { useSearchParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";
const RightCard = ({
  filterStatus,
  selectedExpertises,
  selectedServices,
  selectedLanguages,
  sortStatus,
  searchValue,
  cards,
  setCards,
  max,
  user,
  inboundStatuses,
  userCredits,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [timeElapsed, setTimeElapsed] = useState(1);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalChat, setShowModalChat] = useState(false);
  const [showModalCredit, setShowModalCredit] = useState(false);
  const [showBuyCreditModal, setShowBuyCreditModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [callSeconds, setCallSeconds] = useState({});
  const timersRef = useRef({});
  const [credits, setCredits] = useState("");
  const [searchParams] = useSearchParams();
  const [totalCredits, setTotalCredits] = useState(0);
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/experts/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.error("Language cookie 'lang' not found.");
    }

    const interval = setInterval(() => {
      setTimeElapsed((prevTime) => {
        if (prevTime < 7200) {
          return prevTime + 1;
        }
        clearInterval(interval);
        return prevTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

const getStatusPriority = (card) => {
  const extension = card.services
    ?.flatMap((s) => s.extensions || [])
    ?.find((e) => e.type === "inbound")?.data;

  const status = inboundStatuses?.[extension];

  if (!status) return 3;

  switch (status.label) {
    case "Idle":
      return 1; // Available

    case "InUse":
    case "Ringing":
      return 2; // In call

    case "Unavailable":
      return 3; // Unavailable

    default:
      return 3;
  }
};

/* 
const sortedCards = [...cards].sort((a, b) => {
  return getStatusPriority(a) - getStatusPriority(b);
});
 */
const sortedCards = [...cards].sort((a, b) => {
  if (sortStatus === "reading") {
    return b.readings - a.readings;
  } else if (sortStatus === "rating") {
    return b.rating - a.rating;
  } else if (sortStatus === "newest") {
    return new Date(b.creation_date) - new Date(a.creation_date);
  }

  // Default sort: status
  return getStatusPriority(a) - getStatusPriority(b);
});
  const stopChrono = (extension) => {
    if (timersRef.current[extension]) {
      clearInterval(timersRef.current[extension]);
      delete timersRef.current[extension];
    }

    setCallSeconds((prev) => {
      const newState = { ...prev };
      delete newState[extension];
      return newState;
    });
  };
    const startChrono = (extension, startSeconds = 0) => {
    if (timersRef.current[extension]) return;

    setCallSeconds((prev) => ({
      ...prev,
      [extension]: startSeconds,
    }));

    timersRef.current[extension] = setInterval(() => {
      setCallSeconds((prev) => ({
        ...prev,
        [extension]: (prev[extension] || 0) + 1,
      }));
    }, 1000);
  };
  useEffect(() => {
    if (!inboundStatuses) return;

    Object.entries(inboundStatuses).forEach(([extension, status]) => {
      if (status.label === "InUse" || status.label === "Ringing") {
        let seconds = 0;

        if (status.duration != null) {
          seconds = status.duration;
        } else if (status.durationFormatted) {
          seconds = status.durationFormatted
            .split(":")
            .map(Number)
            .reduce((a, v) => a * 60 + v, 0);
        }

        startChrono(extension, seconds);
      } else {
        stopChrono(extension);
      }
    });

    return () => {
      Object.values(timersRef.current).forEach(clearInterval);
      timersRef.current = {};
    };
  }, [inboundStatuses]);
 
  const handleOpenModal = (expert) => {
    setLoading(true);
    setSelectedExpert(expert);
    setTimeout(() => {
      setShowModal(true);
      setLoading(false);
    }, 800);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedExpert(null);
  };

  const handleOpenModalChat = (expert) => {
    setSelectedExpert(expert);
    setShowModalChat(true);
  };

  const handleCloseModalChat = () => {
    setShowModalChat(false);
    setSelectedExpert(null);
  };

  const handleOpenModalCredit = async (expert) => {
    setSelectedExpert(expert);
    setLoading(true);
    try {
      const res = await api.get(`/content/load`, {
        params: {
          "types[]": "credits",
        },
      });

      const creditsData = res.data?.data?.credits || [];

      setCredits(creditsData);
      const total = creditsData.reduce(
        (total, item) => total + Number(item.credit || 0),
        0,
      );
      setTotalCredits(total);
      if (total > 0) {
        setShowBuyCreditModal(false);
        setShowModalCredit(true);
      } else {
        setShowModalCredit(false);
        setShowBuyCreditModal(true);
      }
    } catch (error) {
      console.error("Error loading credits:", error);
      setShowBuyCreditModal(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cards || !cards.length) return;

    const action = searchParams.get("action");
    const expertId = searchParams.get("expert_id");
    if (!action || !expertId) return;
    const expert = cards.find((c) => String(c.id) === String(expertId));
    if (!expert) return;
    else if (action === "credit") {
      handleOpenModalCredit(expert);
    } else if (action === "chat") {
      handleOpenModalChat(expert);
    }

    // remove params after opening modal
    window.history.replaceState({}, "", "/portal/experts");
  }, [searchParams, cards]);

  useEffect(() => {
    const action = searchParams.get("action");
    const id = searchParams.get("id");

    if (!action || !id) return;

    const expert = cards.find((c) => String(c.id) === String(id));

    if (!expert) return;

    if (action === "prn") {
      handleOpenModal(expert);
    } else if (action === "credit") {
      handleOpenModalCredit(expert);
    } else if (action === "chat") {
      handleOpenModalChat(expert);
    }
  }, [searchParams, cards]);
  if (!languageData) {
    return;
  }




  /* const sortedCards = [...cards].sort((a, b) => {
    if (sortStatus === "availability") {
      const getStatusPriority = (status) => {
        if (status === "available") return 1;
        if (status.includes("in_call")) return 2;
        if (status === "not_available") return 3;
        return 4;
      };

      const priorityA = getStatusPriority(a.status);
      const priorityB = getStatusPriority(b.status);
      return priorityA - priorityB;
    } else if (sortStatus === "reading") {
      return b.readings - a.readings;
    } else if (sortStatus === "rating") {
      return b.rating - a.rating;
    } else if (sortStatus === "newest") {
      return new Date(b.creation_date) - new Date(a.creation_date);
    }
    return 0;
  }); */

  const categorizeCards = () => {
    let filteredCards = [...sortedCards];

    if (selectedExpertises.length > 0) {
      filteredCards = filteredCards.filter((card) => {
        return selectedExpertises.some((expertise) =>
          String(card.expertises)
            .toLowerCase()
            .includes(String(expertise).toLowerCase()),
        );
      });
    }

    if (selectedServices.length > 0) {
      filteredCards = filteredCards.filter((card) => {
        return selectedServices.some((service) =>
          card.services.some((s) =>
            s.communication.toLowerCase().includes(service.toLowerCase()),
          ),
        );
      });
    }

    if (selectedLanguages.length > 0) {
      filteredCards = filteredCards.filter((card) => {
        return selectedLanguages.some((language) =>
          card.languages.some((lang) =>
            lang.toLowerCase().includes(language.toLowerCase()),
          ),
        );
      });
    }

    const allMatches = [];
    const partialMatchesTwo = [];
    const partialMatchesOne = [];

    filteredCards.forEach((card) => {
      const matchingExpertises = selectedExpertises.filter((expertise) =>
        card.expertises.some((exp) =>
          exp.toLowerCase().includes(expertise.toLowerCase()),
        ),
      );
      const matchingServices = selectedServices.filter((service) =>
        card.services.some((s) =>
          s.communication.toLowerCase().includes(service.toLowerCase()),
        ),
      );
      const matchingLanguages = selectedLanguages.filter((language) =>
        card.languages.some((lang) =>
          lang.toLowerCase().includes(language.toLowerCase()),
        ),
      );

      if (
        matchingExpertises.length === selectedExpertises.length &&
        matchingServices.length === selectedServices.length &&
        matchingLanguages.length === selectedLanguages.length
      ) {
        allMatches.push(card);
      } else if (
        matchingExpertises.length +
          matchingServices.length +
          matchingLanguages.length >=
        2
      ) {
        partialMatchesTwo.push(card);
      } else if (
        matchingExpertises.length +
          matchingServices.length +
          matchingLanguages.length >=
        1
      ) {
        partialMatchesOne.push(card);
      }
    });

    return [...allMatches, ...partialMatchesTwo, ...partialMatchesOne];
  };
  const isExpertAvailable = (card) => {
    const extension = card.services
      ?.flatMap((s) => s.extensions || [])
      ?.find((e) => e.type === "inbound")?.data;

    if (!extension) return false;

    return inboundStatuses?.[extension]?.label === "Idle";
  };
  const filteredCards = categorizeCards().filter((card) => {
    const filters = Array.isArray(filterStatus) ? filterStatus : [];
    if (filters.includes("available") && !isExpertAvailable(card)) {
      return false;
    }

    if (
      filters.includes("favorite") &&
      !(card.favorite === true || card.is_favorite === true)
    ) {
      return false;
    }
    const isSearchValid =
      !searchValue ||
      card.nickname.toLowerCase().includes(searchValue.toLowerCase()) ||
      String(card.id).includes(searchValue);
    return isSearchValid;
  });

  const handleCloseModalCredit = () => {
    setShowModalCredit(false);
    setSelectedExpert(null);
  };

  const handleAddClick = async (expertId, isFavorite) => {
    try {
      setLoading(true);

      const endpoint = isFavorite
        ? "/content/wishlist/remove"
        : "/content/wishlist/add";

      const response = await api.post(endpoint, {
        expert_id: expertId,
      });
      if (response.data?.status !== "success") {
        throw new Error("API error");
      }

      setCards((prevCards) =>
        prevCards.map((card) =>
          Number(card.id) === Number(expertId)
            ? { ...card, is_favorite: !isFavorite }
            : card,
        ),
      );
      setLoading(false);
      await Swal.fire({
        position: "top-end",
        icon: "success",
        title: isFavorite
          ? languageData?.alert?.add_favorite?.remove?.description
          : languageData?.alert?.add_favorite?.add?.description,
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
      Swal.fire(
        languageData?.alert?.add_favorite?.error?.title,
        languageData?.alert?.add_favorite?.error?.text,
        "error",
      );
    }
  };

  const SecToDate = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mnt = Math.floor((seconds % 3600) / 60);
    const sec = seconds % 60;

    return `${hrs.toString().padStart(2, "0")}:${mnt
      .toString()
      .padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
  };



  /* const getBadgeConfig = (label, seconds) => {
    switch (label) {
      case "Idle":
        return { className: "available", text: languageData.available };

      case "InUse":
      case "Ringing":
        return {
          className: "orange",
          text: `${languageData.incall} (${SecToDate(seconds)})`,
        };

      case "Unavailable":
      case "Busy":
        return { className: "gray", text: languageData.not_available };

      default:
        return { className: "gray", text: languageData.not_available };
    }
  }; */
  const getBadgeConfig = (label, seconds) => {
    switch (label) {
      case "Idle":
        return {
          className: "available",
          text: languageData.available,
        };

      case "InUse":
      case "Ringing":
        return {
          className: "orange",
          text: `${languageData.incall} (${SecToDate(seconds)})`,
        };

      case "Unavailable":
      case "Busy":
        return {
          className: "gray",
          text: languageData.not_available,
        };

      case "Ready":
      case null:
      case undefined:
        return {
          className: "gray loading",
          text: <span className="status-spinner"></span>,
        };

      default:
        return {
          className: "gray",
          text: languageData.not_available,
        };
    }
  };
  const getInboundBadge = (card) => {
    const extension = card.services
      ?.flatMap((s) => s.extensions || [])
      ?.find((e) => e.type === "inbound")?.data;

    if (!extension) {
      return getBadgeConfig(null, 0);
    }

    const statusObj = inboundStatuses?.[extension];
    const seconds = callSeconds[extension] || 0;

    return getBadgeConfig(statusObj?.label, seconds);
  };
  const getInboundStatus = (card) => {
    const extension = card.services
      ?.flatMap((s) => s.extensions || [])
      ?.find((e) => e.type === "inbound")?.data;

    return extension ? inboundStatuses?.[extension]?.label : null;
  };

  const APP_SERVICES = process.env.REACT_APP_APP_SERVICES;
  const SERVICES = APP_SERVICES.split(",").map((s) => s.trim());
  const hasService = (key) => SERVICES.includes(key);
  return (
    <div className="col-xxl-10 col-xl-9 col-md-8 col-lg-9 col-sm-12 pe-0">
      <div className="row">
        {showSpinner ? (
          <Spinner />
        ) : filteredCards.length === 0 ? (
          <div
            className="no-results d-flex flex-column justify-content-center align-items-center text-center"
            style={{ minHeight: "200px", marginTop: "150px" }}
          >
            <GoPeople style={{ fontSize: "40px", color: "grey" }} />
            <div>
              <h3 className="text-muted">{languageData.no_expert}</h3>
              <p className="text-muted">{languageData.find}</p>
            </div>
          </div>
        ) : (
          filteredCards.map((card) => (
            <div
              key={card.id}
              className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 pe-0"
            >
              <div className="card custom-card product-card">
                <div className="card-header d-block py-2 px-3">
                  <div
                    className="d-sm-flex d-block justify-content-between"
                    ref={(el) => {
                      if (el)
                        el.style.setProperty("display", "flex", "important");
                    }}
                  >
                    <div>
                    </div>

                    <div className="text-sm-end">
                      <span
                        className={`badge fs-12 rounded-1 ${getInboundBadge(card).className}`}
                      >
                        {getInboundBadge(card).text}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-body py-2 px-3">
                  <div
                    className="d-sm-flex align-items-start text-start e-card"
                    ref={(el) => {
                      if (el)
                        el.style.setProperty("display", "flex", "important");
                    }}
                  >
                    <span className="product-image-1">
                      <a data-interaction="expert_image"
                        href={`${process.env.REACT_APP_PLATFORM_URL}/expert-details?id=${card.id}`}
                      >
                        <img
                          src={
                            card.image && card.image.trim() !== ""
                              ? card.image
                              : avatar
                          }
                          className="card-img"
                          alt={card.name}
                        />
                      </a>
                    </span>

                    <div className="ms-4 mt-sm-0">
                      <div className="d-flex align-items-start">
                        <a data-interaction="expert_name"
                          href={`${process.env.REACT_APP_PLATFORM_URL}/expert-details?id=${card.id}`}
                        >
                          <h5 className="product-name fs-16 fw-semibold mb-0">
                            {card.nickname}
                          </h5>
                        </a>
                      </div>

                      <div className="mt-2 mt-sm-2 mb-2">
                        <div className="d-flex align-items-start flex-wrap gap-6p">
                          {card.expertises && Array.isArray(card.expertises) ? (
                            card.expertises.map((expertises, index) => {
                              const expertiseLabel =
                                languageData.card.tools[
                                  expertises.toLowerCase()
                                ];
                              return (
                                <p
                                  key={index}
                                  className="badge bg-info-transparent fs-11 rounded-1 mb-0"
                                >
                                  {expertiseLabel}
                                </p>
                              );
                            })
                          ) : (
                            <p className="badge bg-info-transparent fs-11 rounded-1 mb-0">
                              {card.expertises}{" "}
                            </p>
                          )}
                        </div>
                      </div>

                      <div
                        className="d-flex align-items-start flex-wrap expert_readings"
                      >
                        <div className="d-flex px-2 py-2 border-end">
                          <div className="text-start d-flex flex-column">
                            <p className="fw-semibold mb-0">
                              {languageData.card.favorite}
                            </p>
                            <button data-interaction="add_expert_to_favorite"
                              type="button"   data-expert={card.id}
                              className="btn btn-sm btn-danger-light btn-favorite"
                              onClick={() =>
                                handleAddClick(card.id, card.is_favorite)
                              }
                            >
                              <i
                                className={`${
                                  card.is_favorite === true
                                    ? "ri-heart-fill"
                                    : "ri-heart-line"
                                }`}
                              ></i>
                            </button>
                          </div>
                        </div>
                        <div className="d-flex px-2 py-2 border-end">
                          <div className="text-start">
                            <p className="fw-semibold mb-0">
                              {languageData.card.readings}
                            </p>
                            <span className="text-muted fs-12">
                              {card.readings}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex px-2 py-2 pt-6">
                          <div className="text-start">
                            <p className="fw-semibold mb-0">
                              {languageData.card.ratings}
                            </p>
                            <span className="fs-12 gold">
                              ★ {card.rating}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                   <div  className="align-items-start flex-wrap justify-content-center expert_readings_resp hidden"
                      >
                        <div className="d-flex px-2 py-2 border-end">
                          <div className="text-start d-flex flex-column">
                            <p className="fw-semibold mb-0">
                              {languageData.card.favorite}
                            </p>
                            <button data-interaction="add_expert_to_favorite"
                              type="button"   data-expert={card.id}
                              className="btn btn-sm btn-danger-light btn-favorite"
                              onClick={() =>
                                handleAddClick(card.id, card.is_favorite)
                              }
                            >
                              <i
                                className={`${
                                  card.is_favorite === true
                                    ? "ri-heart-fill"
                                    : "ri-heart-line"
                                }`}
                              ></i>
                            </button>
                          </div>
                        </div>
                        <div className="d-flex px-2 py-2 border-end">
                          <div className="text-start">
                            <p className="fw-semibold mb-0">
                              {languageData.card.readings}
                            </p>
                            <span className="text-muted fs-12">
                              {card.readings}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex px-2 py-2 pt-6">
                          <div className="text-start">
                            <p className="fw-semibold mb-0">
                              {languageData.card.ratings}
                            </p>
                            <span className="fs-12 gold">
                              ★ {card.rating}
                            </span>
                          </div>
                        </div>
                    </div>
                </div>
                <div
                  className="card-footer d-sm-flex d-block align-items-center justify-content-end gap-2 px-3"
                  ref={(el) => {
                    if (el)
                      el.style.setProperty("display", "flex", "important");
                  }}
                >
                  <button
                    type="button" data-interaction="expert_card_call"
                     data-expert={card.id}
                    className={`btn btn-icon btn-wave waves-effect waves-light ${
                      ["Unavailable"].includes(getInboundStatus(card))
    ? "btn-primary"
    : ["InUse", "Ringing"].includes(getInboundStatus(card))
                        ? "bg-orange"
                        : card.services.some(
                              (s) =>
                                hasService("call") && s.call_type === "prn",
                            )
                          ? "btn-secondary"
                          : "btn-primary"
                    }`}
disabled={
  ["Unavailable"].includes(getInboundStatus(card)) ||
  !card.services.some(
    (s) => hasService("call") && s.call_type === "prn",
  )
}
                    /* disabled={
                      !card.services.some(
                        (s) => hasService("call") && s.call_type === "prn",
                      )
                    } */
                    onClick={() => {
                      if(["InUse", "Ringing"].includes(getInboundStatus(card))) return;
                      handleOpenModal(card)}}
                    data-tooltip-id="call_tooltip"
                    data-tooltip-content={languageData.card.communication.call}
                    data-tooltip-place="bottom"
                  >
                    <i className="ri-phone-fill"></i>
                  </button>
                  <Tooltip id="call_tooltip" />
                  <button
                    type="button" data-interaction="expert_card_credit"
                     data-expert={card.id}
                    className={`btn btn-icon btn-wave waves-effect waves-light ${
                      ["Unavailable"].includes(getInboundStatus(card))
    ? "btn-primary"
    : ["InUse", "Ringing"].includes(getInboundStatus(card))
                        ? "bg-orange"
                        : card.services.some(
                              (s) =>
                                hasService("credit") &&
                                s.call_type === "credit",
                            )
                          ? "btn-secondary"
                          : "btn-primary"
                    }`}
                    disabled={
  ["Unavailable"].includes(getInboundStatus(card)) ||
  !card.services.some(
    (s) => hasService("credit") && s.call_type === "credit",
  )
}
                  /*   disabled={
                      !card.services.some(
                        (s) => hasService("credit") && s.call_type === "credit",
                      )
                    } */
                    onClick={() => {
                        if(["InUse", "Ringing"].includes(getInboundStatus(card))) return;
                        handleOpenModalCredit(card)}}
                    data-tooltip-id="credit_tooltip"
                    data-tooltip-content={
                      languageData.card.communication.credit
                    }
                    data-tooltip-place="bottom"
                  >
                    <i className="ri-bank-card-2-line"></i>
                  </button>
                  <Tooltip id="credit_tooltip" />

                  <button data-interaction="expert_card_chat"
                    type="button"
                     data-expert={card.id}
                    className={`btn btn-icon btn-wave waves-effect waves-light ${
                      card.services.some(
                        (s) => hasService("chat") && s.communication === "chat",
                      )
                        ? "btn-secondary"
                        : "btn-primary"
                    }`}
                    disabled={
                      !card.services.some(
                        (s) => hasService("chat") && s.communication === "chat",
                      )
                    }
                    onClick={() => handleOpenModalChat(card)}
                    data-tooltip-id="chat_tooltip"
                    data-tooltip-content={languageData.card.communication.chat}
                    data-tooltip-place="bottom"
                  >
                    <i className="ri-message-2-line"></i>
                  </button>
                  <Tooltip id="chat_tooltip" />

                  <button 
                    type="button" data-interaction="expert_card_email"
                     data-expert={card.id}
                    className={`btn btn-icon btn-wave waves-effect waves-light ${
                      card.services.some(
                        (s) =>
                          hasService("email") && s.communication === "email",
                      )
                        ? "btn-secondary"
                        : "btn-primary"
                    }`}
                    disabled={
                      !card.services.some(
                        (s) =>
                          hasService("email") && s.communication === "email",
                      )
                    }
                    data-tooltip-id="email_tooltip"
                    data-tooltip-content={languageData.card.communication.email}
                    data-tooltip-place="bottom"
                  >
                    <i className="ri-mail-line"></i>
                  </button>
                  <Tooltip id="email_tooltip" />
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      {showModal && (
        <Bycall
          showModal={showModal}
          handleModalClose={handleCloseModal}
          data={{ ...selectedExpert, usercredit: userCredits, max: max }}
          expert={selectedExpert}
        />
      )}
      {showModalChat && (
        <Bychat
          showModalChat={showModalChat}
          handleModalCloseChat={handleCloseModalChat}
          data={{ ...selectedExpert, usercredit: userCredits, max: max }}
          expert={selectedExpert}
        />
      )}
      {showModalCredit && (
        <Bycredit
          showModalCredit={showModalCredit}
          handleModalCloseCredit={handleCloseModalCredit}
          data={{ ...selectedExpert, usercredit: totalCredits, max: max }}
          expert={selectedExpert}
          credits={totalCredits}
        />
      )}
      {showBuyCreditModal && (
        <Buycredit
          show={showBuyCreditModal}
          onClose={() => setShowBuyCreditModal(false)}
          data={{ ...selectedExpert, usercredit: totalCredits, max: max }}
          expert={selectedExpert}
          credits={totalCredits}
        />
      )}

      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
};

export default RightCard;
